import {
  CheckIcon_default
} from "./chunk-4TQ4KLN7.mjs";
export {
  CheckIcon_default as default
};
